import { SearchControl } from "@assets/tsx/searchControl";
import React, { useEffect, useRef, useState } from "react";
import qSearch from '@assets/gql/search.gql';
import qSearchFilters from '@assets/gql/search.filters.gql';
import { useQuery } from "@apollo/client";
import client from "@gql/client";
import { useLang } from "@ambiguous/useLang";
import { getSearchParams } from '@assets/ts/getSearchParams';
import { Link } from "@ambiguous/link";
import { PaginatorButtons } from '@assets/tsx/paginator/buttons';
import { Checkbox } from "@assets/tsx/checkbox";
import { LoadingBox } from "@assets/tsx/loadingBox/loadingBox";
import SidebarModal from "@assets/tsx/sidebarModal/SidebarModal";
import OutsideAlerter from "@assets/tsx/outsideClicker";
import { MenuHeader } from "@widgets/nav-responsive/nav-responsive";
import { useI18n } from "@wordpress/react-i18n";
import { useLocation } from "react-router-dom";
export default function SearchResults({ post_types }) {
    var _a, _b, _c, _d, _e;
    const { __ } = useI18n();
    const location = useLocation();
    let paramQuery = getSearchParams('s'), _page = getSearchParams('page'), pageQuery = _page !== null ? parseInt(_page) : null;
    // url 		= new URL(location.pathname);
    const perPage = 10;
    const [page, setPage] = useState(pageQuery);
    const [checked, setChecked] = useState(post_types || []);
    const [query, setQuery] = useState(paramQuery);
    const [modalOpen, setModalOpen] = useState(false);
    /**
     * Update url params
     */
    const updateURL = (type, newVal) => {
        let searchParams = new URLSearchParams(location.search);
        searchParams.set(type, newVal);
        window.history.replaceState(null, null, `${location.pathname}?${searchParams.toString()}`);
    };
    const handleInputChange = (newVal) => {
        let val = newVal !== '' ? newVal : null;
        setQuery(val);
        setPage(0);
    };
    const handleCheckboxChange = (newVal) => {
        let val = newVal !== '' ? newVal : null;
        setQuery(val);
        setPage(0);
    };
    const handlePageChange = (page) => {
        let val = page;
        setPage(val);
    };
    const [lang] = useLang();
    const { data, loading } = useQuery(qSearch, {
        client,
        variables: {
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase(),
            search: query,
            offset: page * perPage,
            size: perPage,
            contentTypes: (checked === null || checked === void 0 ? void 0 : checked.length) > 0 ? checked.map(c => c.toUpperCase()) : undefined
        }
    });
    const { data: filtersData, loading: filtersLoading } = useQuery(qSearchFilters, { client, variables: {
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        } });
    const items = (_a = data === null || data === void 0 ? void 0 : data.contentNodes) === null || _a === void 0 ? void 0 : _a.nodes;
    const totalItems = ((_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.contentNodes) === null || _b === void 0 ? void 0 : _b.pageInfo) === null || _c === void 0 ? void 0 : _c.offsetPagination) === null || _d === void 0 ? void 0 : _d.total) || 0;
    const totalPages = Math.ceil(totalItems / perPage);
    let filters = (_e = filtersData === null || filtersData === void 0 ? void 0 : filtersData.contentTypes) === null || _e === void 0 ? void 0 : _e.nodes;
    if ((filters === null || filters === void 0 ? void 0 : filters.length) > 0 && (post_types === null || post_types === void 0 ? void 0 : post_types.length) > 0) {
        filters = filters.filter(({ name }) => post_types.includes(name));
    }
    const listRef = useRef(null);
    useEffect(() => {
        if (!page)
            setPage(0);
    }, [query, checked]);
    /**
     * When the laoding is done, update the url param
     */
    useEffect(() => {
        if (!loading) {
            updateURL('s', query);
            updateURL('page', (page || 0).toString());
        }
    }, [loading, query, page, updateURL]);
    return React.createElement("div", { className: "ltg-search-results ltg-list", ref: listRef },
        React.createElement(SidebarModal, { open: modalOpen },
            React.createElement(OutsideAlerter, { className: 'ltg-modal-sidebar-wrap', callback: () => {
                    setModalOpen(false);
                } },
                React.createElement("div", { className: "text-right" },
                    React.createElement(MenuHeader, { setOpen: setModalOpen })),
                React.createElement(Filters, Object.assign({}, { filters, checked, setChecked })))),
        React.createElement(Filters, Object.assign({}, { filters, checked, setChecked })),
        React.createElement("div", null,
            React.createElement("div", { className: "ltg-search-results-control-wrap" },
                React.createElement(SearchControl, { onChange: (newVal) => {
                        handleInputChange(newVal);
                    }, value: query || '' }),
                React.createElement("div", { className: 'ltg-search-results-modal-toggle-wrap' },
                    React.createElement("button", { type: 'button', className: 'btn btn-white btn--shadow', onClick: () => {
                            toggleMenu();
                        } },
                        React.createElement("span", { className: "sr-only" }, __("Filtrai", 'ltg-widgets')),
                        React.createElement("i", { className: "fas fa-sliders-h" })))),
            React.createElement("div", null, loading ? (new Array(perPage).fill('').map((_, index) => React.createElement(LoadingBox, { key: `search-loader-${index}`, style: { height: 100, marginBottom: 16, marginTop: 16 } }))) : (items === null || items === void 0 ? void 0 : items.length) > 0 ? (React.createElement(React.Fragment, null,
                items.map((item) => React.createElement(Item, { key: item.id, data: item, searchText: query })),
                totalPages > 1 &&
                    React.createElement("div", { className: "ltg-list-pagination" },
                        React.createElement(PaginatorButtons, { total: totalPages, onClick: (page) => {
                                handlePageChange(page);
                                (listRef === null || listRef === void 0 ? void 0 : listRef.current) && (listRef === null || listRef === void 0 ? void 0 : listRef.current.scrollIntoView({ behavior: 'smooth' }));
                            }, page: page })))) : (React.createElement("div", { className: "no-results" },
                React.createElement("h1", { role: 'presentation' }, __("Rezultatų nėra", 'ltg-widgets')))))));
    function toggleMenu() {
        setModalOpen(o => !o);
    }
}
const Item = ({ data, searchText }) => {
    var _a, _b, _c, _d;
    const uri = data === null || data === void 0 ? void 0 : data.uri;
    const label = (_a = data === null || data === void 0 ? void 0 : data.seo) === null || _a === void 0 ? void 0 : _a.title;
    const searchDescription = data === null || data === void 0 ? void 0 : data.searchDescription;
    const breadcrumbs = (_c = (_b = data === null || data === void 0 ? void 0 : data.seo) === null || _b === void 0 ? void 0 : _b.breadcrumbs) === null || _c === void 0 ? void 0 : _c.slice(1);
    const date = (_d = data === null || data === void 0 ? void 0 : data.date) === null || _d === void 0 ? void 0 : _d.substring(0, 10);
    return React.createElement(Link, { href: uri, className: 'ltg-list-item' },
        React.createElement("h4", { className: "ltg-list-item-title" },
            React.createElement(MarkedText, { text: label, searchText: searchText })),
        React.createElement("p", null,
            React.createElement(MarkedText, { text: searchDescription, searchText: searchText })),
        React.createElement("small", { className: "text-muted" },
            date,
            " | ", breadcrumbs === null || breadcrumbs === void 0 ? void 0 :
            breadcrumbs.map(((crumb) => crumb.text)).join(' | ')));
};
function Filters({ filters, checked, setChecked }) {
    const { __ } = useI18n();
    return React.createElement("div", { className: "ltg-search-results-filters" },
        React.createElement("h2", { role: "presentation" }, __('Filtras', 'ltg-widgets')), filters === null || filters === void 0 ? void 0 :
        filters.map(({ id, label, name }) => (React.createElement(Checkbox, { checked: checked.includes(name), label: label, id: name, key: id, onChange: () => {
                const index = checked.indexOf(name);
                setChecked(index === -1 ? [...checked, name] : checked.filter(c => c !== name));
            } }))));
}
function MarkedText({ searchText, text }) {
    if (searchText === '')
        return React.createElement(React.Fragment, null, text);
    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = text.split(regex);
    return (React.createElement(React.Fragment, null, parts.map((part, index) => regex.test(part) ? (React.createElement("mark", { key: index, dangerouslySetInnerHTML: { __html: part } })) : (React.createElement("span", { key: index, dangerouslySetInnerHTML: { __html: part } })))));
}
